<template>
  <div>
    <h3 class="checkout-h3 pb-3">Resumo do seu Pedido #{{eventID}} - {{ $route.name === 'commissioner' && orderPdvData ? orderPdvData.codigo : orderID }}</h3>
  </div>
</template>

<script>
export default {
  computed: {
    postOrder() {
      return this.$store.getters.postOrder;
    },
    orderPdvData() {
      return this.$store.getters.orderPdvData;
    },
    orderID() {
      return this.$store.getters.body.codigo_pedido;
    },
    eventID() {
      return this.$store.getters.eventID;
    },
  }
};
</script>


